import { render, staticRenderFns } from "./leavecontent.vue?vue&type=template&id=310d3700"
import script from "./leavecontent.vue?vue&type=script&lang=js"
export * from "./leavecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports